import { createReducer } from 'redux-act';
import ActionTypes from './ActionTypes';
import Node from './Node';
import { Pop } from './Node';

const reducer = createReducer(
    {
        [ActionTypes.add as any]: (state: Node, pop: Pop) => {
            const popList = state.popList.slice();
            pop.isHide = false;
            popList.push(pop);
            return {
                ...state,
                popList,
            };
        },

        [ActionTypes.remove as any]: (state: Node) => {
            const popList = state.popList.slice();
            popList.pop();
            return {
                ...state,
                popList,
            };
        },

        [ActionTypes.removeAll as any]: (state: Node) => {
            const popList = state.popList.slice();
            popList.forEach(e => {
                e.isHide = true;
            });
            return {
                ...state,
                popList,
            };
        },

        [ActionTypes.removeHide as any]: (state: Node) => {
            const popList = state.popList.slice();
            if(popList.length > 0){
                popList[popList.length - 1].isHide = true;
            }
            return {
                ...state,
                popList,
            };
        },
    },
    new Node()
);

export default reducer;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/redux/reducers/rightPopUps/reducer.ts